import { Link } from "react-router-dom";

export type Crumb = {
  label: string;
  to?: string;
};

type BreadcrumbsProps = {
  items: Crumb[];
  invert?: boolean;
};

export default function Breadcrumbs({ items, invert = false }: BreadcrumbsProps) {
  const base = invert ? "text-background-100 hover:text-background-50" : "text-foreground-600 hover:text-primary-600";
  const sep = invert ? "text-background-100/60" : "text-foreground-400";
  const current = invert ? "text-background-50" : "text-foreground-900";

  return (
    <nav aria-label="面包屑导航" className="flex flex-wrap items-center gap-2 text-sm">
      <Link to="/" className={`flex items-center gap-1 whitespace-nowrap transition-colors ${base}`}>
        <i className="ri-home-4-line" />
        首页
      </Link>
      {items.map((item, index) => (
        <span key={`${item.label}-${index}`} className="flex items-center gap-2">
          <i className={`ri-arrow-right-s-line ${sep}`} />
          {item.to ? (
            <Link to={item.to} className={`whitespace-nowrap transition-colors ${base}`}>
              {item.label}
            </Link>
          ) : (
            <span className={`line-clamp-1 max-w-[14rem] md:max-w-md ${current}`}>{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}